var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class ChangeUploadType {
  constructor(_data) {
    /**
     */
    __publicField(this, "UploadType");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof ChangeUploadType
     */
    __publicField(this, "$type", "V1.Cesop.Periods.ChangeUploadType");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.UploadType = ChangeUploadTypeUploadType[_data["UploadType"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["UploadType"] = ChangeUploadTypeUploadType[this.UploadType];
    return _data;
  }
}
export var ChangeUploadTypeUploadType = /* @__PURE__ */ ((ChangeUploadTypeUploadType2) => {
  ChangeUploadTypeUploadType2["Csv"] = "Csv";
  ChangeUploadTypeUploadType2["Xml"] = "Xml";
  ChangeUploadTypeUploadType2["Empty"] = "Empty";
  return ChangeUploadTypeUploadType2;
})(ChangeUploadTypeUploadType || {});
